import DocsFilters from './styled';

export default DocsFilters;
